import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as moment from 'moment'
import { GranServicioDePTWService } from '../gran-servicio-de-ptw.service'
import { ServicioLoadersAlertasService } from '../servicio-loaders-alertas.service'
import * as firebase from 'firebase'
import { AlertController, ToastController, LoadingController } from '@ionic/angular';


@Component({
  selector: 'app-modal-editar-trabajador',
  templateUrl: './modal-editar-trabajador.page.html',
  styleUrls: ['./modal-editar-trabajador.page.scss'],
})
export class ModalEditarTrabajadorPage implements OnInit {

  @Input() trabajadorID;



  nombre = ''
  tipoID = ''
  cedula = ''
  telefono = ''
  arl = ''
  fechaAfiliacionARL = ''
  urlParafiscales = ''
  docId = ''
  arraydeactividades = []
  actividadSeleccionada = ''
  subiendo = ''
  urlCertificadoAlturas = ''
  urlCertificadoAptitud = ''
  urlCertificadoIzaje = ''
  urlCertificadoCONTE = ''
  urlCertificadoConfinados = ''
  urlCertificadoAptitudConfinados = ''
  urlCertificadoEquiposConfinados = ''
  arraydeSoportes = []

  //--variables de subir parafiscales
  changedData = true
  percentage = 0;


  constructor(public granServicioDePTWService: GranServicioDePTWService, public servicioLoadersAlertasService: ServicioLoadersAlertasService, public modalCtrl: ModalController, public loadingController: LoadingController) { }

  ngOnInit() {

  }

  ionViewWillEnter() {
    this.servicioLoadersAlertasService.presentLoading("Cargando datos empleado...")
    this.queryTrabajador()
      .then((trabajador) => { this.cargaCampos(trabajador) })
      .then(() => { this.servicioLoadersAlertasService.loadingController.dismiss() })
  }

  queryTrabajador() {
    return new Promise((resolve, reject) => {
      let query = firebase.firestore().collection("trabajadores").doc(this.trabajadorID)
      query.get().then((doc) => {
        resolve(doc.data())
      }).then(() => {
        query.onSnapshot((doc) => {
          this.cargaCampos(doc.data())
        });
      }).catch((err) => {
        reject(err)
      })
    })
  }

  cargaCampos(empleado) {
    console.log("nombre en cargacampos" + empleado.nombre)
    return new Promise((resolve) => {
      this.arl = empleado.arl;
      this.arraydeSoportes = empleado.arraydeSoportes;
      this.cedula = empleado.cedula;
      this.fechaAfiliacionARL = empleado.fechaAfiliacionARL;
      this.nombre = empleado.nombre;
      this.telefono = empleado.telefono;
      this.tipoID = empleado.tipoID;
      this.urlParafiscales = empleado.urlParafiscales;
      this.urlCertificadoAlturas = empleado.urlCertificadoAlturas;
      this.urlCertificadoAptitud = empleado.urlCertificadoAptitud;
      this.urlCertificadoIzaje = empleado.urlCertificadoIzaje;
      this.urlCertificadoCONTE = empleado.urlCertificadoCONTE;
      this.urlCertificadoConfinados = empleado.urlCertificadoConfinados;
      this.urlCertificadoAptitudConfinados = empleado.urlCertificadoAptitudConfinados;
      this.urlCertificadoEquiposConfinados = empleado.urlCertificadoEquiposConfinados;
      resolve("")
    })
  }






  formateafechaparadisplay() {
    this.fechaAfiliacionARL = moment(this.fechaAfiliacionARL).format('YYYY-MM-DD');
  }




  inputfile(event, nombreparametro) {
    this.servicioLoadersAlertasService.presentLoading("Cargando archivo...");

    this.subiendo = nombreparametro
    this.changedData = true
    this.percentage = 0;
    // File or Blob named mountains.jpg
    var file = event.target.files[0]

    // Create the file metadata
    var metadata = {
      // contentType: 'image/jpeg'
    };
    // Upload file and metadata to the object 'images/mountains.jpg'
    let storageRef = firebase.storage().ref('parafiscales/' + Date.now())
    var uploadTask = storageRef.child('images/' + file.name).put(file, metadata);

    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded

        this.percentage = (snapshot.bytesTransferred / snapshot.totalBytes)
        console.log('Upload is ' + this.percentage + '% done');
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log('Upload is paused');
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log('Upload is running');
            break;
        }
      }, (error) => {
        console.log(error);
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        this.loadingController.dismiss()
        this.servicioLoadersAlertasService.alerta("Error", error)
      }, () => {
        // Upload completed successfully, now we can get the download URL
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          console.log('File available at', downloadURL);


          //cada vez que cargamos un soporte, lo actualizamos en firebase
          let query = firebase.firestore().collection("trabajadores").doc(this.trabajadorID)

          if (nombreparametro == 'parafiscales') {
            this.urlParafiscales = downloadURL
            query.update({ urlParafiscales: this.urlParafiscales }).then(() => {
              this.loadingController.dismiss()
            })

          }
          if (nombreparametro == 'Cert. trabajo en alturas') {
            this.urlCertificadoAlturas = downloadURL
            query.update({ urlCertificadoAlturas: this.urlCertificadoAlturas }).then(() => {
              this.loadingController.dismiss()
            })
            // this.arraydeSoportes.push({actividad:"TRABAJO EN ALTURAS",documento:nombreparametro,url:downloadURL})

          }
          if (nombreparametro == 'Cert. aptitud ocupacional') {
            this.urlCertificadoAptitud = downloadURL
            query.update({ urlCertificadoAptitud: this.urlCertificadoAptitud }).then(() => {
              this.loadingController.dismiss()
            })
            // this.arraydeSoportes.push({actividad:"TRABAJO EN ALTURAS",documento:nombreparametro,url:downloadURL})
          }
          if (nombreparametro == 'Cert. para izaje') {
            this.urlCertificadoIzaje = downloadURL
            query.update({ urlCertificadoIzaje: this.urlCertificadoIzaje }).then(() => {
              this.loadingController.dismiss()
            })
            // this.arraydeSoportes.push({actividad:"LEVANTAMIENTO MECÁNICO",documento:nombreparametro,url:downloadURL})

            console.log("ARRAY DE SOPORTES: " + this.arraydeSoportes)
          }
          if (nombreparametro == 'Cert. conte') {
            this.urlCertificadoCONTE = downloadURL
            query.update({ urlCertificadoCONTE: this.urlCertificadoCONTE }).then(() => {
              this.loadingController.dismiss()
            })
            // this.arraydeSoportes.push({actividad:"ENERGÍAS PELIGROSAS",documento:nombreparametro,url:downloadURL})
          }
          if (nombreparametro == 'Cert. confinados') {
            this.urlCertificadoConfinados = downloadURL
            query.update({ urlCertificadoConfinados: this.urlCertificadoConfinados }).then(() => {
              this.loadingController.dismiss()
            })
            // this.arraydeSoportes.push({actividad:"ESPACIOS CONFINADOS",documento:nombreparametro,url:downloadURL})
          }
          if (nombreparametro == 'Cert. aptitud confinados') {
            this.urlCertificadoAptitudConfinados = downloadURL
            query.update({ urlCertificadoAptitudConfinados: this.urlCertificadoAptitudConfinados }).then(() => {
              this.loadingController.dismiss()
            })
            // this.arraydeSoportes.push({actividad:"ESPACIOS CONFINADOS",documento:nombreparametro,url:downloadURL})
          }
          if (nombreparametro == 'Cert. equipos confinados') {
            this.urlCertificadoEquiposConfinados = downloadURL
            query.update({ urlCertificadoEquiposConfinados: this.urlCertificadoEquiposConfinados }).then(() => {
              this.loadingController.dismiss()
            })
            // this.arraydeSoportes.push({actividad:"ESPACIOS CONFINADOS",documento:nombreparametro,url:downloadURL})
          }

          this.loadingController.dismiss()

        }).catch((err) => {
          this.loadingController.dismiss()
          this.servicioLoadersAlertasService.alerta("Error", err)
        });

      });
  }





  deleteDocument(url, nombredeldocumento) {
    // Create a reference to the file to delete
    var httpsReference = firebase.storage().refFromURL(url)
    // Delete the file
    httpsReference.delete().then(() => {

      // File deleted successfully
      console.log("Deleted OK")

      let query = firebase.firestore().collection("trabajadores").doc(this.trabajadorID)

      this.percentage = 0
      if (nombredeldocumento == 'parafiscales') { this.urlParafiscales = ''; query.update({ urlParafiscales: this.urlParafiscales }) } else
      if (nombredeldocumento == 'certificadoAlturas') { this.urlCertificadoAlturas = ''; query.update({ urlCertificadoAlturas: this.urlCertificadoAlturas }) } else
      if (nombredeldocumento == 'CertificadoAptitud') { this.urlCertificadoAptitud = ''; query.update({ urlCertificadoAptitud: this.urlCertificadoAptitud }) } else
      if (nombredeldocumento == 'certificadoIzaje') { this.urlCertificadoIzaje = ''; query.update({ urlCertificadoAlturas: this.urlCertificadoAlturas }) } else
      if (nombredeldocumento == 'certificadoCONTE') { this.urlCertificadoCONTE = ''; query.update({ urlCertificadoCONTE: this.urlCertificadoCONTE }) } else
      if (nombredeldocumento == 'certificadoConfinados') { this.urlCertificadoConfinados = ''; query.update({ urlCertificadoConfinados: this.urlCertificadoConfinados }) } else
      if (nombredeldocumento == 'CertificadoAptitudConfinados') { this.urlCertificadoAptitudConfinados = ''; query.update({ urlCertificadoAptitudConfinados: this.urlCertificadoAptitudConfinados }) } else
      if (nombredeldocumento == 'CertificadoEquiposConfinados') { this.urlCertificadoEquiposConfinados = ''; query.update({ urlCertificadoEquiposConfinados: this.urlCertificadoEquiposConfinados }) }

    }).catch((error) => {

      let query = firebase.firestore().collection("trabajadores").doc(this.trabajadorID)

      if(error.code=='storage/object-not-found'){
        if (nombredeldocumento == 'parafiscales') { query.update({ urlParafiscales: ""}).then(()=>{this.servicioLoadersAlertasService.alerta("Registro eliminado","Registro eliminado. Puede cargar un nuevo soporte")}) } else
        if (nombredeldocumento == 'certificadoAlturas') { query.update({ urlCertificadoAlturas: ""}).then(()=>{this.servicioLoadersAlertasService.alerta("Registro eliminado","Registro eliminado. Puede cargar un nuevo soporte")}) } else
        if (nombredeldocumento == 'CertificadoAptitud') { query.update({ urlCertificadoAptitud: ""}).then(()=>{this.servicioLoadersAlertasService.alerta("Registro eliminado","Registro eliminado. Puede cargar un nuevo soporte")}) } else
        if (nombredeldocumento == 'certificadoIzaje') { query.update({ urlCertificadoAlturas: "" }).then(()=>{this.servicioLoadersAlertasService.alerta("Registro eliminado","Registro eliminado. Puede cargar un nuevo soporte")}) } else
        if (nombredeldocumento == 'certificadoCONTE') { query.update({ urlCertificadoCONTE: ""}).then(()=>{this.servicioLoadersAlertasService.alerta("Registro eliminado","Registro eliminado. Puede cargar un nuevo soporte")}) } else
        if (nombredeldocumento == 'certificadoConfinados') { query.update({ urlCertificadoConfinados: "" }).then(()=>{this.servicioLoadersAlertasService.alerta("Registro eliminado","Registro eliminado. Puede cargar un nuevo soporte")}) } else
        if (nombredeldocumento == 'CertificadoAptitudConfinados') {query.update({ urlCertificadoAptitudConfinados: ""}).then(()=>{this.servicioLoadersAlertasService.alerta("Registro eliminado","Registro eliminado. Puede cargar un nuevo soporte")}) } else
        if (nombredeldocumento == 'CertificadoEquiposConfinados') {query.update({ urlCertificadoEquiposConfinados: "" }).then(()=>{this.servicioLoadersAlertasService.alerta("Registro eliminado","Registro eliminado. Puede cargar un nuevo soporte")}) }
      }else{
        this.servicioLoadersAlertasService.alerta("¡Error!", error)
      }
      
    });
  }


  cancelar() {
    this.modalCtrl.dismiss();
  }



  update() {
    let query = firebase.firestore().collection("trabajadores").doc(this.trabajadorID)
    query.update({
      arl: this.arl,
      tipoID: this.tipoID,
      cedula: this.cedula,
      fechaAfiliacionARL: this.fechaAfiliacionARL,
      nombre: this.nombre,
      telefono: this.telefono,
      urlParafiscales: this.urlParafiscales,
      urlCertificadoAlturas: this.urlCertificadoAlturas,
      urlCertificadoAptitud: this.urlCertificadoAptitud,
      urlCertificadoIzaje: this.urlCertificadoIzaje,
      urlCertificadoCONTE: this.urlCertificadoCONTE,
      urlCertificadoConfinados: this.urlCertificadoConfinados,
      urlCertificadoAptitudConfinados: this.urlCertificadoAptitudConfinados,
      urlCertificadoEquiposConfinados: this.urlCertificadoEquiposConfinados
    }).then(()=>{
      this.modalCtrl.dismiss()
      

    }).catch((err)=>{
      this.modalCtrl.dismiss()
      this.servicioLoadersAlertasService.alerta("Error",err)
    })
  }




}//fin de clase

